export default __webpack_public_path__ + "afe61e83ea388f0d901abf4b050a3e82.jpg";